<script>
    import { onMount, createEventDispatcher } from 'svelte'
    import moment from 'moment'

    // export let value
    export let months = 36


    let monthsList      = [],
        mmnt            = moment().date(15)

    const dispatch = createEventDispatcher ();
        
    const onChange = (event) => {
        dispatch ('month-change', event.target.value)
    }

    onMount (() => {
        for (var j = 0; j < months; j++) {
            monthsList.unshift ({ text: mmnt.format ('MMMM YYYY'), value: mmnt.valueOf() })
            mmnt.subtract (1, 'months').date(15);
        }
        monthsList = monthsList;
        dispatch ('month-change', monthsList[monthsList.length - 1].value)
    })
</script>

<style>
    .PeriodSelector {
        height: 30px;
        padding: 0;
        border-radius: 0;
        border: 0;
        outline: 0;
        font-size: 14px;
        font-weight: 600;
        color: #586d7d;
        /* background-color: #dbe4ea; */
        -webkit-appearance: none;
        border-radius: 2px;
        background-color: var(--sidelink-hover);
        position: relative;
    }

    .PeriodSelector .dropdown {
        display: inline-block;
        border: none;
        outline: none;
        color: #586d7d;
        font-size: 13px;
        font-weight: 600;
        padding: 5px 10px;
        margin: 0;
        width: 100%;
        background: transparent;
        -webkit-appearance: none;
    }
</style>

<div class="PeriodSelector">
    <!-- svelte-ignore a11y-no-onchange -->
    <select class="dropdown" name="start" value="" on:change={onChange}>
        {#each monthsList as month (month.value)}
            <option value={month.value}>{month.text}</option>
        {/each}
    </select>
</div>